export default __webpack_public_path__ + "static/film-and-animation-9c99698f34a4fb7ea55fcbbbf26a2341.jpg";